module.exports = __webpack_public_path__ + "static/logo-c492f42279b21cd7ad2d62e0e49b75da.png";